import React from "react";
import { Typography } from "common";

export function OrderNumberTableCell({ id = "N/A" }) {
  return <Typography component="div" fontSize="large" value={id} />;
}
